/*
  Fuego & Fragancia — aviso de idioma.

  CÓMO VIAJA LA ELECCIÓN, y por qué así.

  Antes se intentó de dos maneras y las dos rebotaban: el idioma cambiaba un
  segundo y volvía al anterior.

    1ª — escribir la cookie y cambiar la URL a mano. El navegador empezaba a
         cargar la página nueva antes de que la cookie quedara guardada, así
         que llegaba sin la marca de "ya decidió" y la detección automática
         devolvía al visitante a su idioma de dispositivo.

    2ª — enviar el formulario nativo de Shopify. Sigue dependiendo de que la
         cookie se escriba antes de que arranque la petición, y además de a
         dónde decida volver Shopify después.

  Las dos comparten el mismo punto débil: se escribe algo AQUÍ y se espera que
  esté disponible ALLÁ.

  La solución es no depender de eso. El idioma elegido viaja en la propia URL
  (?ff_lang=en). Al llegar a la página nueva, ff-locale.js lee ese parámetro,
  escribe la cookie ya en destino y se aparta. No hay carrera posible: el dato
  llega dentro de la misma petición que lo necesita.

  Usage: se renderiza desde snippets/ff-lang-prompt.liquid
*/
window.FF_LOCALE_COOKIE = 'ff_locale_choice';

window.ffLocaleGetChoice = function () {
  // El separador entre cookies es punto y coma mas ESPACIO, no eses. Se
  // parte la cadena en vez de arriesgar otra expresion regular: ver la
  // nota larga de leerCookie en ff-locale.js, el mismo fallo dejaba la
  // eleccion de idioma invisible y el aviso volvia a salir en cada pagina.
  var trozos = document.cookie ? document.cookie.split(String.fromCharCode(59)) : [];
  for (var i = 0; i < trozos.length; i += 1) {
    var trozo = trozos[i].trim();
    if (trozo.indexOf("ff_locale_choice=") === 0) {
      var crudo = trozo.slice("ff_locale_choice=".length);
      try {
        return decodeURIComponent(crudo);
      } catch (e) {
        return crudo;
      }
    }
  }
  return "";
};

window.ffLocaleSaveChoice = function (valor) {
  const unAno = 60 * 60 * 24 * 365;
  document.cookie =
    'ff_locale_choice=' + encodeURIComponent(valor) + ';path=/;max-age=' + unAno + ';SameSite=Lax';
};

if (!customElements.get('ff-lang-prompt')) {
  customElements.define(
    'ff-lang-prompt',
    class FfLangPrompt extends HTMLElement {
      connectedCallback() {
        // Ya decidió antes (cookie de un año): ni se muestra.
        if (window.ffLocaleGetChoice()) return;

        /*
          AQUI NO VA UN FRENO DE "ya se enseno una vez", y conviene dejarlo
          escrito porque estuvo puesto y hubo que quitarlo.

          Habia una marca en sessionStorage: el aviso salia en la primera
          pagina y ya no volvia en toda la visita. La intencion era no ser
          pesado, pero el efecto real era peor: quien todavia no habia
          decidido nada y pasaba a otra pagina perdia el aviso para siempre,
          sin forma de recuperarlo. Se quedaba en el idioma que le tocara.

          El unico freno es la cookie de decision, arriba. Mientras el
          visitante no elija un idioma ni cierre con la X, el aviso lo
          acompana pagina a pagina. En cuanto decide algo -lo que sea- no
          vuelve a aparecer en un ano.
        */

        if (window.location.search.indexOf('ff_nolocale=1') !== -1) return;

        this.querySelectorAll('[data-ff-langp-pick]').forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            this.irAlIdioma(btn);
          });
        });

        const cerrar = this.querySelector('[data-ff-langp-close]');
        if (cerrar) {
          cerrar.addEventListener('click', () => {
            // Cerrar también es decidir: se queda con lo que está viendo.
            window.ffLocaleSaveChoice(this.dataset.current || 'dismissed');
            this.ocultar();
          });
        }

        const espera = (parseFloat(this.dataset.delay) || 3) * 1000;
        this.timer = setTimeout(() => this.mostrar(), espera);
      }

      irAlIdioma(btn) {
        const iso = btn.dataset.ffLangpPick;
        const raiz = this.normalizar(btn.dataset.root);
        const raizActual = this.normalizar(this.dataset.currentRoot);

        // La cookie se escribe igualmente por si la navegación es instantánea
        // y da tiempo; el parámetro de la URL es el que garantiza el resultado.
        window.ffLocaleSaveChoice(iso);

        // Se conserva la página en la que está: solo cambia el prefijo.
        let ruta = window.location.pathname;
        if (raizActual && ruta.indexOf(raizActual) === 0) {
          ruta = ruta.slice(raizActual.length) || '/';
        }
        if (ruta.charAt(0) !== '/') ruta = '/' + ruta;

        const parametros = new URLSearchParams(window.location.search);
        parametros.set('ff_lang', iso);

        window.location.href = raiz + ruta + '?' + parametros.toString() + window.location.hash;
      }

      // root_url vale "/" en el idioma principal sin prefijo; ahí no hay nada
      // que anteponer ni que recortar.
      normalizar(valor) {
        if (!valor || valor === '/') return '';
        return valor.charAt(valor.length - 1) === String.fromCharCode(47) ? valor.slice(0, -1) : valor;
      }

      mostrar() {
        this.hidden = false;
        // Un fotograma de margen: sin él el navegador pinta el estado final de
        // golpe y no se ve la transición de entrada.
        requestAnimationFrame(() => this.classList.add('is-open'));
      }

      ocultar() {
        this.classList.remove('is-open');
        setTimeout(() => {
          this.hidden = true;
        }, 450);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }
    }
  );
}
